/**
 * Building Hermes-Inspired Capabilities into EAKC
 * 30-slide animated explainer — captured 24 May 2026
 * Dark cinematic + neon house style (shared with EAKCSecurity).
 */

export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

export const COLORS = {
  bg: "#050B18",
  bgCard: "#121D38",
  bgCardLight: "#1A2548",
  neonPink: "#FF2D95",
  neonBlue: "#00D4FF",
  neonPurple: "#A855F7",
  neonGreen: "#00FF88",
  neonOrange: "#FF6B35",
  neonYellow: "#FFD60A",
  neonCyan: "#00E5FF",
  neonRed: "#FF3366",
  neonLime: "#84FF57",
  neonAmber: "#FFB020",
  textPrimary: "#FFFFFF",
  textSecondary: "#B8C5E0",
  textMuted: "#6B7DA0",
};

export const FONTS = {
  heading: "Inter, SF Pro Display, system-ui, sans-serif",
  body: "Inter, SF Pro Text, system-ui, sans-serif",
  mono: "JetBrains Mono, SF Mono, Fira Code, monospace",
};

export const SPRING = {
  snappy: { damping: 200, mass: 0.5 },
  bouncy: { damping: 100, mass: 0.5 },
  gentle: { damping: 150, mass: 0.8 },
  slow: { damping: 120, mass: 1.2 },
  punch: { damping: 80, mass: 0.4 },
};

export const TOTAL_SLIDES = 30;

/** Per-slide durations in frames (30 fps). Index 0 = slide 01. */
export const SLIDE_DURATIONS: number[] = [
  270, // 01 Title
  300, // 02 The 2026 shift
  315, // 03 Meet Hermes
  315, // 04 Continual Harness
  300, // 05 Groundhog-day problem
  315, // 06 Meet EAKC
  315, // 07 EAKC fragmentation
  315, // 08 Capability matrix
  300, // 09 What EAKC already had
  315, // 10 The real gaps
  300, // 11 The big idea: the Skill
  315, // 12 Anatomy of a skill
  360, // 13 The 12 skill kinds
  330, // 14 Skill kinds in action #1
  330, // 15 Skill kinds in action #2
  330, // 16 The skill lifecycle
  315, // 17 Where skills come from
  330, // 18 The applier
  315, // 19 UI #1 chat nudge
  330, // 20 UI #2 /admin/learned
  315, // 21 UI #3 mission timeline
  330, // 22 UI #4 memory inspector
  300, // 23 Chat: the past
  330, // 24 Chat: the present + Default agent
  315, // 25 The honest gap
  315, // 26 The flywheel
  345, // 27 Long-term advantages
  330, // 28 GitHub-grounded reality
  360, // 29 Demo gallery
  330, // 30 Closing
];

export const TOTAL_DURATION = SLIDE_DURATIONS.reduce((a, b) => a + b, 0);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
